import Empresa from '@/empresa/empresa.view.vue';
import Home from '@/views/home.view.vue';
import { API_URL } from '@/common/constantes.ts';
import AgregarEventoEmpresa from '@/empresa/agregar-evento.view.vue';
import RegistrarEmpresa from '@/empresa/registrar-empresa.view.vue';
import AdministrarEmpresa from '@/empresa/administrar-empresa.vue';

export const empresa = {
  path: '/empresa',
  name: 'Empresa',
  component: Empresa,
  redirect: '/empresa/administrar',
  children: [
    {
      path: 'link',
      name: 'EmpresaLink',
      component: Home,
      beforeEnter() {
        location.href = `${API_URL}/empresa/link`;
      },
    },
    {
      path: 'evento',
      name: 'AgregarEventoEmpresa',
      component: AgregarEventoEmpresa,
    },
    {
      path: 'registrar',
      name: 'RegistrarEmpresa',
      component: RegistrarEmpresa,
    },
    {
      path: 'administrar',
      name: 'AdministrarEmpresa',
      component: AdministrarEmpresa,
    },
  ],
};
